export function deriveAudioTitleFromSegments(
  segments: { speaker: string; text: string }[],
): string {
  const combined = segments
    .map((s) => s.text)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();
  if (!combined) {
    return "Audio";
  }
  const max = 72;
  if (combined.length <= max) {
    return combined;
  }
  const cut = combined.slice(0, max);
  const lastSpace = cut.lastIndexOf(" ");
  const shortened = lastSpace > 24 ? cut.slice(0, lastSpace) : cut;
  return `${shortened}…`;
}

export function displayTitleForAudioItem(
  title: string,
  extractedSegmentsJson: string,
): string {
  const t = title?.trim() ?? "";
  if (t && t !== "Untitled audio") {
    return t;
  }
  try {
    const segments = JSON.parse(extractedSegmentsJson) as { speaker: string; text: string }[];
    if (Array.isArray(segments) && segments.length > 0) {
      return deriveAudioTitleFromSegments(segments);
    }
  } catch {
    /* ignore */
  }
  return t || "Audio";
}
